// /publicCenters 종류 / 상태 코드 → 라벨 / 색 매핑 (route-local 도메인 지식).

import type { StatusChipColor } from "components/list";

interface StatusMeta {
  label: string;
  color: StatusChipColor;
}

// 시설 종류(kindOf) 라벨/색. "기타" 폴백은 publicCentersColumns.tsx의 renderCell에서 처리한다
// (제네릭 resolveStatusMeta는 원본 값을 그대로 반환하므로 여기서 처리하지 않음).
export const kindOfMeta: Record<string, StatusMeta> = {
  Kindergarten: { label: "유치원", color: "primary" },
  ChildHouse: { label: "어린이집", color: "info" },
};

// 시설 상태(status)
export const statusMeta: Record<string, StatusMeta> = {
  정상: { label: "정상", color: "success" },
  폐지: { label: "폐지", color: "error" },
};

// 매핑에 없는 값도 안전하게 표시
export const resolveStatusMeta = (
  map: Record<string, StatusMeta>,
  value: unknown
): StatusMeta => {
  const key = value === null || value === undefined ? "" : String(value);
  return map[key] ?? { label: key || "-", color: "default" };
};
